import EventDispatcher from '@/core/event/eventDispatcher';
import ApplicationEvent from '@/core/event/applicationEvent';

let _startView;
let _themeParam;
let _content;
let _pageVisible = true;
const _breakpoints:string[] = [];
let _currentViewID = '';

export default class CoreApplicationStateModel {

    static get startView() {
        return _startView;
    }

    static set startView(value) {
        _startView = value;
    }

    static set themeParam(value) {
        _themeParam = value;
    }

    static get themeParam() {
        // this changed to no longer be a key, but a remote API route (MPI's CMS)
        return _themeParam;
    }

    static get content() {
        return _content;
    }

    static set content(value) {
        _content = value;
    }

    static set pageVisible(value) {
        let old_value = _pageVisible;
        _pageVisible = value;
        if (old_value != value) {
            EventDispatcher.dispatchEvent(new ApplicationEvent(ApplicationEvent.PAGE_VISIBILITY_CHANGED, value));
        }
    }

    static get pageVisible() {
        return _pageVisible;
    }

    static get breakpoints() {
        return _breakpoints;
    }

    static set breakpoints(value:string[]) {
        _breakpoints.length = 0;
        for (let item of value) {
            _breakpoints.push(item);
        }
    }

    static set currentViewID(viewID) {
        _currentViewID = viewID;
        EventDispatcher.dispatchEvent(new ApplicationEvent(ApplicationEvent.VIEW_CHANGED, viewID));
    }

    static get currentViewID() {
        return _currentViewID;
    }

}
